import { render, staticRenderFns } from "./SumupResultDownload.vue?vue&type=template&id=0370faca&"
import script from "./SumupResultDownload.vue?vue&type=script&lang=ts&"
export * from "./SumupResultDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports